import { render, staticRenderFns } from "./confirmBoxInbound.vue?vue&type=template&id=70969f84&scoped=true&"
import script from "./confirmBoxInbound.vue?vue&type=script&lang=js&"
export * from "./confirmBoxInbound.vue?vue&type=script&lang=js&"
import style0 from "./confirmBoxInbound.vue?vue&type=style&index=0&id=70969f84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70969f84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70969f84')) {
      api.createRecord('70969f84', component.options)
    } else {
      api.reload('70969f84', component.options)
    }
    module.hot.accept("./confirmBoxInbound.vue?vue&type=template&id=70969f84&scoped=true&", function () {
      api.rerender('70969f84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/temporaryTemplate/goodsInbound/confirmBoxInbound.vue"
export default component.exports